import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/administrator.jpg'


const _hoisted_1 = { class: "dropdown admin-profile" }
const _hoisted_2 = {
  class: "d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_3 = { class: "flex-grow-1 ms-2" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "d-none d-xxl-block" }
const _hoisted_6 = { class: "d-flex align-content-center" }
const _hoisted_7 = { class: "dropdown-menu border-0 bg-white dropdown-menu-end" }
const _hoisted_8 = { class: "d-flex align-items-center info" }
const _hoisted_9 = { class: "flex-grow-1 ms-2" }
const _hoisted_10 = { class: "fw-medium" }
const _hoisted_11 = { class: "fs-12" }
const _hoisted_12 = { class: "admin-link ps-0 mb-0 list-unstyled" }

import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import { onMounted, ref } from "vue";
import { db } from "@/database/db";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminProfile',
  setup(__props) {

const authStore = useAuthStore();
const userLogin = ref({});

onMounted(async () => {
  const { success } = await authStore.dispatchInitialize();
  let getData = await db.storage.get("login-info");
  userLogin.value = getData?.data;
});

const actLogout = async () => {
  await authStore.dispatchLogout();
  router.push("/");
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-shrink-0" }, [
        _createElementVNode("img", {
          class: "rounded-circle wh-40 administrator",
          src: _imports_0,
          alt: "admin"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", null, _toDisplayString(userLogin.value?.user?.username), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-shrink-0" }, [
          _createElementVNode("img", {
            class: "rounded-circle wh-30 administrator",
            src: _imports_0,
            alt: "admin"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h3", _hoisted_10, _toDisplayString(userLogin.value?.user?.name), 1),
          _createElementVNode("span", _hoisted_11, _toDisplayString(userLogin.value?.job?.name), 1)
        ])
      ]),
      _createElementVNode("ul", _hoisted_12, [
        _createElementVNode("li", null, [
          _createVNode(_component_RouterLink, {
            class: "dropdown-item d-flex align-items-center text-body",
            to: `/general/admin-profile/` + userLogin.value?.user?.id
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "material-symbols-outlined" }, "account_circle", -1),
              _createElementVNode("span", { class: "ms-2" }, "My Profile", -1)
            ])),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("ul", { class: "admin-link ps-0 mb-0 list-unstyled" }, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "dropdown-item d-flex align-items-center text-body",
            onClick: actLogout,
            href: "javascript:;"
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "logout", -1),
            _createElementVNode("span", { class: "ms-2" }, "Logout", -1)
          ]))
        ])
      ])
    ])
  ]))
}
}

})